module.exports = __webpack_public_path__ + "static/img/_13.dc3e91ba.png";